import React, { useEffect, useState } from 'react';
import styles from './AddMeal.module.css';
import { useDispatch, useSelector } from 'react-redux';
import {
  addMealRedux,
  removeMealRedux,
  addMealItemRedux,
  addIngredientRedux,
  addTitleIngredientRedux,
  addSubIngredientRedux,
  removeIngredientsGropRedux,
  removeIngredientRedux,
  onChangeIngredientRedux,
  addIngredientByIndexRedux,
} from '../../store/slices/menuSlice';

import { ListSvg, PlateSvg, SettingSvg, CloseSvg } from '../../SVGComponents/SVGComponents';
import LoaderPage from '../LoaderPage/LoaderPage';
import PopupAddIngredient from '../PopupAddIngredient/PopupAddIngredient';
import { bodyScrollOverflowHidden } from '../../helper';
import { getDocsOrderByBd } from '../../firebase';
import { getObjectIngredient } from '../../helperProject';
import MealControl from '../MealControl/MealControl';

export default function AddMeal({ mealName }) {
  // console.log(mealName);
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(true);
  const [popupIngredients, setPopupIngredients] = useState(false);
  const [showBtnList, setShowBtnList] = useState(false);

  const menuText = useSelector((state) => state.menu.menuDay[mealName].menuText);
  const menuTwoServings = useSelector((state) => state.menu.menuDay[mealName].twoServings);
  const menuMealRepeatMenu = useSelector((state) => state.menu.menuDay[mealName].repeatMenu);

  const mealTitle = useSelector((state) => state.menu.menuDay[mealName].title);
  const mealTitleBtn = useSelector((state) => state.menu.menuDay[mealName].titleBtn);

  const [ingredientsArray, setIngredientsArray] = useState([]);

  useEffect(() => {
    // setLoader(true);
    const getIngredients = async () => {
      // (colectionName, getOrderBy, byOrder = '')
      const ingredients = await getDocsOrderByBd('ingredients', 'text');
      if (ingredients) {
        setIngredientsArray(ingredients);
      }
    };
    getIngredients();
    setLoader(false);
  }, []);

  const addMeal = (mealName) => {
    dispatch(addMealRedux(mealName));
  };
  // Видаляє страву
  const removeMeal = (mealName, menuIndex) => {
    let isRemove = window.confirm(`Видалити Cтраву №${menuIndex + 1} ?`);
    if (isRemove) {
      dispatch(removeMealRedux({ mealName, menuIndex }));
    }
  };
  //
  const addMealItem = (mealName, menuIndex, inputValue, itemName) => {
    dispatch(addMealItemRedux({ mealName, menuIndex, inputValue, itemName }));
  };
  // Додає інгридієнт
  const addIngredient = (mealName, menuIndex, ingredientsItem) => {
    dispatch(addIngredientRedux({ mealName, menuIndex, ingredientsItem }));
  };
  // Додає інгридієнт по вказаному індексу
  const addIngredientByIndex = (
    mealName,
    menuIndex,
    ingredientsItem,
    indexIngredient,
    titleIngredients,
  ) => {
    dispatch(
      addIngredientByIndexRedux({
        mealName,
        menuIndex,
        ingredientsItem,
        indexIngredient,
        titleIngredients,
      }),
    );
    setShowBtnList(false);
  };
  // Додає заголовок в інгридієнтах
  const addTitleIngredient = (mealName, menuIndex) => {
    dispatch(
      addTitleIngredientRedux({
        mealName,
        menuIndex,
        ingredientsItem: { ...getObjectIngredient(), ifAddBasket: false },
      }),
    );
  };
  // Додає інгридієнт в заміну інгридієнтів
  const addSubIngredient = (mealName, menuIndex, indexIngredientGropIndex) => {
    dispatch(
      addSubIngredientRedux({
        mealName,
        menuIndex,
        indexIngredientGropIndex,
        subIngredient: getObjectIngredient(),
      }),
    );
  };
  // Видаляє групу інгридієнтів
  const removeIngredientsGrop = (mealName, menuIndex, indexIngredientGropIndex) => {
    // console.log('removeIngredientsGrop/');
    let isRemove = window.confirm('Видалити?');
    if (isRemove) {
      dispatch(removeIngredientsGropRedux({ mealName, menuIndex, indexIngredientGropIndex }));
    }
    setShowBtnList(false);
  };
  // Видаляє інгридієнт
  const removeIngredient = (mealName, menuIndex, indexIngredientGropIndex, indexIngredient) => {
    // console.log('removeIngredientsGrop/');
    let isRemove = window.confirm('Видалити іргридієнт?');
    if (isRemove) {
      dispatch(
        removeIngredientRedux({ mealName, menuIndex, indexIngredientGropIndex, indexIngredient }),
      );
    }
  };
  // При зміні value інпута інгридієнта
  const onChangeInputIngredient = (
    mealName,
    menuIndex,
    indexIngredientGropIndex,
    indexIngredient,
    inputValue,
  ) => {
    // console.log('onChangeInputIngredient/inputValue ===', inputValue);
    dispatch(
      onChangeIngredientRedux({
        mealName,
        menuIndex,
        indexIngredientGropIndex,
        indexIngredient,
        inputValue,
      }),
    );
  };

  const isShowBtnList = ({ mealName, menuIndex, indexIngredientGropIndex }) => {
    // showBtnList, setShowBtnList
    if (
      showBtnList &&
      showBtnList.mealName === mealName &&
      showBtnList.menuIndex === menuIndex &&
      showBtnList.indexIngredientGropIndex === indexIngredientGropIndex
    ) {
      setShowBtnList(false);
      return;
    }
    setShowBtnList({ mealName, menuIndex, indexIngredientGropIndex });
  };
  //===============================================================

  const getPopupAddIngredient = (props) => {
    bodyScrollOverflowHidden();

    setPopupIngredients(props);
  };

  const ifMacros = (ingredient) => {
    if (
      ingredient.сaloriesIngredient ||
      ingredient.proteinIngredient ||
      ingredient.fatsIngredient ||
      ingredient.carbohydratesIngredient
    ) {
      return '';
    }
    return styles.ingredient_input_noMacros;
  };

  const renderIngredient = (
    mealName,
    menuIndex,
    indexIngredientGropIndex,
    ingredientsItems,
    titleIngredients,
  ) => {
    // console.log('renderIngredient/mealName === ', mealName);
    // console.log('renderIngredient/menuIndex === ', menuIndex);
    // console.log('renderIngredient/indexIngredientGropIndex === ', indexIngredientGropIndex);
    // console.log('renderIngredient/ingredientsItems === ', ingredientsItems);
    // console.log('renderIngredient/titleIngredients === ', titleIngredients);
    return ingredientsItems.map((ingredient, indexIngredient) => {
      return (
        <div key={ingredient.id} className={styles.ingredient_wrapper}>
          {titleIngredients ? (
            <>
              <input
                type="text"
                className={styles.ingredient_input + ' ' + styles.ingredient_input_title}
                placeholder="Заголовок..."
                value={ingredient.text}
                onChange={(e) =>
                  onChangeInputIngredient(
                    mealName,
                    menuIndex,
                    indexIngredientGropIndex,
                    indexIngredient,
                    e.target.value,
                  )
                }
              />
              <div className={styles.ingredient_btn_wrapper}>
                <button
                  className={styles.ingredient_btn_minus}
                  onClick={() =>
                    removeIngredientsGrop(mealName, menuIndex, indexIngredientGropIndex)
                  }>
                  -
                </button>
              </div>
            </>
          ) : indexIngredient === 0 ? (
            <>
              <input
                type="text"
                className={
                  styles.ingredient_input +
                  ' ' +
                  styles.ingredient_input_main +
                  ' ' +
                  ifMacros(ingredient)
                }
                placeholder="Інгридієнт основний..."
                readOnly
                value={ingredient.text}
                onChange={(e) =>
                  onChangeInputIngredient(
                    mealName,
                    menuIndex,
                    indexIngredientGropIndex,
                    indexIngredient,
                    e.target.value,
                  )
                }
              />
              <div className={styles.ingredient_btn_wrapper}>
                <button
                  className={styles.ingredient_btn_plus_main}
                  onClick={() => addSubIngredient(mealName, menuIndex, indexIngredientGropIndex)}>
                  +
                </button>
                <button
                  className={styles.ingredient_btn + ' ' + styles.ingredient_btn_menu}
                  onClick={() =>
                    isShowBtnList({
                      mealName,
                      menuIndex,
                      indexIngredientGropIndex,
                    })
                  }>
                  {showBtnList &&
                  showBtnList.mealName === mealName &&
                  showBtnList.menuIndex === menuIndex &&
                  showBtnList.indexIngredientGropIndex === indexIngredientGropIndex ? (
                    <CloseSvg />
                  ) : (
                    <ListSvg />
                  )}
                </button>

                <button
                  className={styles.ingredient_btn_basket_main}
                  onClick={() =>
                    getPopupAddIngredient({
                      mealName,
                      menuIndex,
                      indexIngredientGropIndex,
                      indexIngredient,
                      handleClick: setPopupIngredients,
                    })
                  }>
                  <PlateSvg />
                </button>

                {showBtnList &&
                showBtnList.mealName === mealName &&
                showBtnList.menuIndex === menuIndex &&
                showBtnList.indexIngredientGropIndex === indexIngredientGropIndex ? (
                  <div className={styles.ingredient_list_btn_wrapper}>
                    <button
                      className={styles.ingredient_btn + ' ' + styles.ingredient_btn_minus_main}
                      onClick={() =>
                        removeIngredientsGrop(mealName, menuIndex, indexIngredientGropIndex)
                      }>
                      -
                    </button>
                    <button
                      className={styles.ingredient_btn_plus_main + ' ' + styles.plus_ingredient_btn}
                      onClick={() =>
                        addIngredientByIndex(
                          mealName,
                          menuIndex,
                          getObjectIngredient(),
                          indexIngredientGropIndex,
                          false,
                        )
                      }>
                      +
                    </button>
                    <button
                      className={
                        styles.ingredient_btn_plus_main + ' ' + styles.plus_ingredient_title_btn
                      }
                      onClick={() =>
                        addIngredientByIndex(
                          mealName,
                          menuIndex,
                          { ...getObjectIngredient(), ifAddBasket: false },
                          indexIngredientGropIndex,
                          true,
                        )
                      }>
                      +
                    </button>
                    <div className={styles.ingredient_list_element}></div>
                  </div>
                ) : (
                  ''
                )}
              </div>
            </>
          ) : (
            <div className={styles.ingredient_replacement_wrapper}>
              <input
                type="text"
                className={styles.ingredient_input + ' ' + ifMacros(ingredient)}
                placeholder="Інгридієнт заміна..."
                value={ingredient.text}
                readOnly
                onChange={(e) =>
                  onChangeInputIngredient(
                    mealName,
                    menuIndex,
                    indexIngredientGropIndex,
                    indexIngredient,
                    e.target.value,
                  )
                }
              />
              <div className={styles.ingredient_btn_wrapper}>
                <button
                  className={styles.ingredient_btn_minus}
                  onClick={() =>
                    removeIngredient(mealName, menuIndex, indexIngredientGropIndex, indexIngredient)
                  }>
                  -
                </button>
                <button
                  className={styles.ingredient_btn_basket_main}
                  onClick={() =>
                    getPopupAddIngredient({
                      mealName,
                      menuIndex,
                      indexIngredientGropIndex,
                      indexIngredient,
                      handleClick: setPopupIngredients,
                    })
                  }>
                  <PlateSvg />
                </button>
              </div>
            </div>
          )}
        </div>
      );
    });
  };

  const renderIngredients = (mealName, menuIndex, ingredients) => {
    // console.log('renderIngredients/mealName === ', mealName);
    // console.log('renderIngredients/menuIndex === ', menuIndex);
    // console.log('renderIngredients/ingredients === ', ingredients);

    return ingredients.map((ingredientItem, indexIngredientGropIndex) => {
      // console.log('renderIngredients/ingredientItem === ', ingredientItem);
      return (
        <div key={ingredientItem.id}>
          {renderIngredient(
            mealName,
            menuIndex,
            indexIngredientGropIndex,
            ingredientItem.ingredientsItems,
            ingredientItem.titleIngredients,
          )}
        </div>
      );
    });
  };
  // Рендеритиь меню
  const renderMenu = (menuArray, mealName) => {
    // console.log('renderMenu/menuArray', menuArray);
    // console.log('mealName', mealName);
    return menuArray.map((menuItem, menuIndex) => {
      return (
        <div key={menuItem.id} className={styles.meal_wrapper}>
          <h4>Страва №{menuIndex + 1}</h4>
          <input
            type="text"
            className={styles.input_meal_title}
            placeholder="Назва страви..."
            value={menuItem.title}
            onChange={(e) => addMealItem(mealName, menuIndex, e.target.value, 'title')}
          />
          Інгридієнти:
          <div className={styles.ingredients_wrapper}>
            {renderIngredients(mealName, menuIndex, menuItem.ingredients)}
          </div>
          <div className={styles.ingredient_main_btn_wrapper}>
            <button
              className={styles.ingredient_btn + ' ' + styles.plus_ingredient_btn}
              onClick={() => addIngredient(mealName, menuIndex, getObjectIngredient())}>
              +
            </button>
            <button
              className={styles.ingredient_btn + ' ' + styles.plus_ingredient_title_btn}
              onClick={() => addTitleIngredient(mealName, menuIndex)}>
              +
            </button>
          </div>
          <textarea
            rows="5"
            className={styles.meal_text_textarea}
            placeholder="Як готувати цю страву..."
            value={menuItem.text}
            onChange={(e) => addMealItem(mealName, menuIndex, e.target.value, 'text')}></textarea>
          <input
            type="text"
            className={styles.input_meal_title}
            placeholder="Посилання на відео..."
            value={menuItem.videoUrl}
            onChange={(e) => addMealItem(mealName, menuIndex, e.target.value.trim(), 'videoUrl')}
          />
          <button
            className={styles.remove_meal_btn}
            onClick={() => removeMeal(mealName, menuIndex)}>
            Видалити цю страву
          </button>
        </div>
      );
    });
  };

  return (
    <div
      className={
        menuTwoServings
          ? styles.item_wrapper + ' ' + styles.item_wrapper_twoServings
          : styles.item_wrapper
      }>
      <h2 className={styles.item_title}>{mealTitle}</h2>
      <div className={styles.meals_container}>
        <MealControl mealName={mealName} />
        <div className={styles.meals_wrapper}>{renderMenu(menuText, mealName)}</div>
        {!menuMealRepeatMenu && (
          <button className={styles.add_meal_btn} onClick={() => addMeal(mealName)}>
            {mealTitleBtn}
          </button>
        )}
      </div>
      {loader && <LoaderPage />}
      {popupIngredients && (
        <PopupAddIngredient {...popupIngredients} ingredientsArray={ingredientsArray} />
      )}
    </div>
  );
}
